import { put, select, takeLatest } from 'redux-saga/effects';
import { calculateAllCustomersInfo, calculateCustomersInfo } from '../../lib';
import { getAllLockers, getSiteLockers } from '../lockers/selectors';
import { errorReceiveAllCalculatedCustomersInfo, errorReceiveCalculatedCustomersInfo, failedReceiveAllCalculatedCustomersInfo, failedReceiveCalculatedCustomersInfo, receiveAllCalculatedCustomersInfo, receiveCalculatedCustomersInfo } from './slice';
export function* receiveAllCustomersInfo(action) {
    try {
        const { consumerAPI } = action.payload;
        const allLockers = yield select(getAllLockers);
        const allCustomersInfo = calculateAllCustomersInfo(allLockers, consumerAPI);
        if (!allCustomersInfo || Object.keys(allCustomersInfo).length < 1) {
            yield put(errorReceiveAllCalculatedCustomersInfo());
        }
        else {
            yield put(receiveAllCalculatedCustomersInfo(allCustomersInfo));
        }
    }
    catch (e) {
        yield put(failedReceiveAllCalculatedCustomersInfo());
    }
}
export function* receiveCustomersInfo(action) {
    try {
        const { consumerAPI } = action.payload;
        const lockers = yield select(getSiteLockers);
        const customersInfo = calculateCustomersInfo(lockers, consumerAPI);
        if (!customersInfo || Object.keys(customersInfo).length < 1) {
            yield put(errorReceiveCalculatedCustomersInfo());
        }
        else {
            yield put(receiveCalculatedCustomersInfo(customersInfo));
        }
    }
    catch (e) {
        yield put(failedReceiveCalculatedCustomersInfo());
    }
}
export function* watchReceiveAllCustomersInfo() {
    yield takeLatest('customersInfo/receiveAllCustomersInfo', receiveAllCustomersInfo);
}
export function* watchReceiveCustomersInfo() {
    yield takeLatest('customersInfo/receiveCustomersInfo', receiveCustomersInfo);
}
